<template>
  <div class="info_zk flex" style="align-items: flex-start">
    <div @click="$router.replace('enterprise')">
      <div class="flex" style="color: #409eff; cursor: pointer">
        <i class="el-icon-caret-left"></i>
        返回
      </div>
    </div>
    <el-card
      style="width: 80%"
      shadow="always"
      :body-style="{ padding: '20px', height: '94%', position: 'relative' }"
    >
      <div class="flex" style="position: relative; align-items: start">
        <div class="flexColumn" style="width: 7%">
          <!-- <el-avatar
            src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
            :size="90"
          ></el-avatar> -->

          <el-upload
            class="avatar-uploader wid-hei90"
            :action="actionS"
            accept=".jpeg,.jpg,.png"
            ref="upload"
            :data="Uids"
            :auto-upload="false"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :on-change="imageChange"
            :headers="importHeaders"
          >
            <el-avatar
              :src="
                imageUrl.length > 0
                  ? imageUrl
                  : $store.state.baseUrl + $store.state.userInfo.user07
              "
              :error="
                () => {
                  return true;
                }
              "
              :style="
                $store.state.userInfo.user07 ? '' : 'background-color:#007eff'
              "
            >
              <img
                src="../../../assets/img/用户头像-女.png"
                v-if="$store.state.userInfo.user03 == '女'"
                class="user-avatar"
              />
              <img
                src="../../../assets/img/用户头像-男.png"
                v-else
                class="user-avatar"
              />
            </el-avatar>
          </el-upload>
          <div style="font-weight: bold">{{ personForm.user02 }}</div>
        </div>
        <h1
          v-if="tabsName != '3'"
          style="width: 50%; font-weight: 700; font-size: 20px"
        >
          用户信息
        </h1>
        <div v-else class="lineColor">
          <div
            class="flex"
            style="height: 100%; padding: 0 100px; color: white"
          >
            <div class="flex">
              <img src="../../../assets/img/Framemoney.png" alt="" />
              <div style="font-size: 20px; margin-left: 10px">当前积分：</div>
              <div style="font-weight: bold; font-size: 36px">
                {{ personForm.user15 }}
              </div>
            </div>
            <div
              class="flex"
              style="
                border: 1px solid white;
                border-radius: 6px;
                padding: 12px;
                width: 28%;
              "
            >
              <img src="../../../assets/img/Framemoney.png" alt="" />
              <div class="flexColumn" style="width: 60%">
                <div>每日签到+50</div>
                <div style="width: 100%">
                  <el-progress
                    :format="format"
                    :percentage="$store.state.userInfo.isSign ? 100 : 0"
                    color="#fff"
                  ></el-progress>
                </div>
              </div>
              <div>
                <el-button
                  :disabled="$store.state.userInfo.isSign"
                  size="mini"
                  style="background: transparent; color: white"
                  @click="Addscorerecord"
                  >{{
                    $store.state.userInfo.isSign ? "已签到" : "签到"
                  }}</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <span class="lineSpan"></span>
      <div class="content">
        <el-tabs
          v-model="tabsName"
          :tab-position="tabPosition"
          style="height: 100%"
          @tab-click="tabClick"
        >
          <el-tab-pane name="1" class="userInfoMenu" style="height: 100%">
            <span slot="label">
              <img src="../../../assets/img/user.png" alt="" />
              我的信息</span
            >
            <div style="width: 100%; height: 100%">
              <el-form
                ref="personForm"
                :model="personForm"
                :rules="rules"
                label-width="80px"
                class="flexColumn"
                style="height: 100%"
              >
                <el-row :gutter="24" style="width: 100%; height: 80%">
                  <el-col :span="12" :offset="0" style="padding: 0 50px">
                    <el-form-item label="账号">
                      <el-input
                        v-model="personForm.user16"
                        style="width: 80%"
                        disabled
                        readonly
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" required prop="user02">
                      <el-input
                        v-model="personForm.user02"
                        style="width: 80%"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="性别">
                      <el-radio-group v-model="personForm.user03">
                        <el-radio label="男"></el-radio>
                        <el-radio label="女"></el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="电话">
                      <el-input
                        placeholder="请输入内容"
                        v-model="personForm.user05"
                        style="width: 80%"
                        disabled
                        class="input-with-select"
                      >
                        <el-button slot="append" @click="changePhone"
                          >修改</el-button
                        >
                      </el-input>
                    </el-form-item>
                    <el-form-item label="密码">
                      <el-input
                        type="password"
                        placeholder="请输入内容"
                        v-model="personForm.user06"
                        style="width: 80%"
                        disabled
                        class="input-with-select"
                      >
                        <el-button slot="append" @click="changePassword"
                          >修改</el-button
                        >
                      </el-input>
                    </el-form-item>
                    <el-form-item label="邮箱">
                      <el-input
                        placeholder="请输入内容"
                        v-model="personForm.user04"
                        style="width: 80%"
                        class="input-with-select"
                      >
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" :offset="0" style="padding: 0 50px">
                    <el-form-item label="所属企业">
                      <el-input
                        placeholder="请输入企业邀请码"
                        disabled
                        v-model="personForm.Company"
                        style="width: 80%"
                        class="input-with-select"
                      >
                        <el-button slot="append" @click="addTree()">{{
                          personForm.Company == null ? "加入" : "修改"
                        }}</el-button>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="所属部门">
                      <el-select
                        style="width: 80%"
                        v-model="personForm.user09"
                        placeholder="请选择部门"
                        @change="selectDept"
                        filterable
                      >
                        <el-option
                          v-for="(item, index) in deps"
                          :key="index"
                          :label="item.dept02"
                          :value="item.dept01"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24" style="height: 10%; width: 20%">
                  <el-col :span="24" :offset="0">
                    <el-form-item label-width="0" style="margin: 0">
                      <el-button
                        type="primary"
                        style="width: 100%"
                        @click="submitForm('personForm')"
                        >保存</el-button
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane
            name="2"
            style="height: 100%; padding: 0 20px; position: relative"
          >
            <span slot="label">
              <img src="../../../assets/img/info.png" alt="" />
              消息通知</span
            >
            <div
              class="flex"
              style="cursor: pointer; position: relative; width: 100%"
            >
              <div>
                <div @click="toggleSelection(msgList)" v-if="checkboxShow">
                  全选
                </div>
              </div>
              <div style="width: 6%">
                <div v-if="!checkboxShow" @click="checkboxShow = true">
                  批量管理
                </div>
                <div class="flex" style="width: 100%">
                  <div
                    v-if="checkboxShow"
                    @click="deleteInBatches"
                    style="color: red"
                  >
                    删除
                  </div>
                  <div
                    v-if="checkboxShow"
                    @click="checkboxShow = false"
                    style="color: #409eff"
                  >
                    取消
                  </div>
                </div>
              </div>
            </div>
            <el-table
              ref="multipleTable"
              :data="msgList"
              v-loading="tableLoading"
              element-loading-text="构件加载中..."
              height="560"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                v-if="checkboxShow"
                type="selection"
                width="45"
              ></el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <div class="flex" style="justify-content: start">
                    <img
                      src="@/assets/img/FrameMessang.png"
                      @click="cellClass"
                      alt=""
                    />
                    <div style="align-items: start; margin-left: 10px">
                      <div>{{ scope.row.msif04 }}</div>
                      <div>{{ scope.row.msif05 }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="address" width="150">
                <template slot-scope="scope">
                  <div v-if="scope.row.msif03">
                    <el-button
                      type="primary"
                      size="mini"
                      v-if="scope.row.msif06 == null"
                      @click="agreeMsg(scope.row.msif01)"
                      >同意</el-button
                    >
                    <el-button
                      v-if="scope.row.msif06 == null"
                      type="danger"
                      size="mini"
                      @click="refuseMsg(scope.row.msif01)"
                      >拒绝</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      v-if="scope.row.msif06 == 1"
                      >已通过</el-button
                    >
                    <el-button
                      v-if="scope.row.msif06 == 0"
                      type="danger"
                      size="mini"
                      >已拒绝</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane name="3" style="height: 100%">
            <span slot="label">
              <img src="../../../assets/img/jifen.png" alt="" />
              我的积分</span
            >
            <div
              class="userInfoMenu"
              style="padding: 20px; width: 97%; height: 92%"
            >
              <el-tabs v-model="jifenActive">
                <el-tab-pane label="积分管理" name="first">
                  <div style="padding: 20px">
                    <div class="flex" style="justify-content: start">
                      <img src="../../../assets/img/Group41.png" alt="" />
                      <div style="margin-left: 10px">
                        积分：{{ personForm.user15 }}
                      </div>
                    </div>
                    <div
                      class="flex"
                      style="justify-content: start; margin: 20px 0"
                    >
                      <img src="../../../assets/img/Vector (1).png" alt="" />
                      <div style="margin-left: 10px">称号：{{ pointInt }}</div>
                    </div>
                    <div class="flexColumn" style="width: 12%">
                      <img
                        src="../../../assets/img/image9.png"
                        width="160"
                        alt=""
                      />
                      <div style="font-weight: bold; margin-top: 10px">
                        积分不足请联系管理员
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="积分记录" name="second">
                  <div
                    style="padding: 20px; height: 54vh; overflow: auto"
                    class="hiddenScroll"
                  >
                    <el-table
                      height="500"
                      v-loading="tableLoading"
                      element-loading-text="记录加载中..."
                      :data="IntegrateList"
                      stripe
                    >
                      <el-table-column
                        prop="scrc05"
                        fixed
                        label="时间"
                      ></el-table-column>
                      <el-table-column
                        prop="scrc03"
                        label="详细说明"
                      ></el-table-column>
                      <el-table-column fixed prop="address" label="收入/支出">
                        <template slot-scope="scope">
                          <div
                            :style="{
                              color:
                                scope.row.scrc06 == 1
                                  ? '#FF0303'
                                  : scope.row.scrc06 == 2 ||
                                    scope.row.scrc06 == 3 ||
                                    scope.row.scrc06 == 4
                                  ? '#035DFF'
                                  : '#999',
                            }"
                          >
                            {{
                              scope.row.scrc06 == 1
                                ? "-"
                                : scope.row.scrc06 == 2 ||
                                  scope.row.scrc06 == 3 ||
                                  scope.row.scrc06 == 4
                                ? "+"
                                : ""
                            }}{{ scope.row.scrc04 }}
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <el-dialog
      title="更换新手机号"
      center
      :append-to-body="true"
      :visible.sync="PhoneVisible"
      width="30%"
    >
      <el-form
        :model="updatePhoneForm"
        ref="updatePhoneForm"
        :rules="rulesPhone"
      >
        <el-form-item prop="newPhone" label="手机号" label-width="120px">
          <el-input
            v-model="updatePhoneForm.newPhone"
            type="password"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item
          required
          prop="smscode"
          label="验证码"
          label-width="120px"
        >
          <el-input
            class="input-with-select"
            v-model="updatePhoneForm.smscode"
            type="number"
            autocomplete="off"
            placeholder="请输入验证码"
          ></el-input>
          <el-button type="text" @click="send" size="small" class="elbut"
            >发送验证码</el-button
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="PhoneVisible = false">取 消</el-button>
        <el-button type="primary" @click="updatePhoneBtn('updatePhoneForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="修改密码"
      center
      :append-to-body="true"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <el-form
        :model="updatePwdForm"
        ref="ruleForm"
        :rules="rulespwd"
        label-width="150px"
      >
        <el-form-item prop="oldpwd" label="旧密码">
          <el-input
            v-model="updatePwdForm.oldpwd"
            type="password"
            autocomplete="off"
            placeholder="请输入旧密码"
          ></el-input>
        </el-form-item>
        <el-form-item required prop="newpwd" label="新密码">
          <el-input
            v-model="updatePwdForm.newpwd"
            type="password"
            autocomplete="off"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item required prop="newpwd1" label="再次确认新密码">
          <el-input
            v-model="updatePwdForm.newpwd1"
            type="password"
            autocomplete="off"
            placeholder="请再次输入新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updatePwdFormBtn('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 图片剪裁 -->
    <el-dialog title="图片剪裁" :visible.sync="picDialogVisible" append-to-body>
      <div class="cropper-content">
        <div
          class="cropper"
          style="text-align: center; width: auto; height: 300px"
        >
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :centerBox="option.centerBox"
            :full="true"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :canMove="option.canMove"
            :fixedBox="option.fixedBox"
            :fixedNumber="option.fixedNumber"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="picDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetuserInfo,
  GetMsginform,
  HandleMsg,
  DelMsg,
  Getscorerecord,
  Addscorerecord,
  GetDeptZTree,
  ChangeCompanyId,
  UpdateUserDept,
  UpdatePwd,
  UpdatePhone,
  SendSMSAsync,
  UpdateUserNameSexEamil,
  GetConsumeScore,
  UploadUserImg,
} from "@/setAxios";
import { mapGetters } from "vuex";
var validatorPhone = function (rule, value, callback) {
  if (value === "") {
    callback(new Error("手机号不能为空"));
  } else if (
    !/^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/.test(
      value
    )
  ) {
    callback(new Error("手机格式错误"));
  } else {
    callback();
  }
};
export default {
  name: "info_zk",
  components: {},
  data() {
    return {
      actionS: this.$store.state.baseUrl + "/api/UploadUserImg",
      Uids: {
        uid: "",
      },
      importHeaders: { token: localStorage.getItem("token") },
      checkboxShow: false,
      jifenActive: "first",
      tabPosition: "left",
      tabsName: "1",
      rules: {
        user02: [
          { required: true, message: "请输入用户姓名", trigger: "blur" },
        ],
      },
      personForm: {}, //用戶信息
      imageUrl: "",
      picDialogVisible: false,
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 100, // 默认生成截图框宽度
        autoCropHeight: 100, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: true, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        canMove: false,
      },
      // picsList: [], //页面显示的数组
      // 防止重复提交
      loading: false,
      fileinfo: {},
      // 消息通知列表
      msgList: [],
      tableLoading: false,
      ids: [],
      IntegrateList: [], //积分列表
      IntegrateShow: true,
      IntegrateName: "签到",
      deps: [],
      // 修改密码
      dialogVisible: false,
      updatePwdForm: {
        oldpwd: "",
        newpwd: "",
        newpwd1: "",
      },
      // 检验条件
      rulespwd: {
        oldpwd: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newpwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 3, message: "长度3位以上", trigger: "blur" },
        ],
        newpwd1: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
        ],
      },
      // 更换手机号
      PhoneVisible: false,
      updatePhoneForm: {
        newPhone: "",
        smscode: "",
      },
      rulesPhone: {
        newPhone: [
          { required: true, validate: validatorPhone, trigger: "blur" },
        ],
        smscode: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
        ],
      },
      pointInt: "助理工程师", //称号
    };
  },
  computed: {
    ...mapGetters(["uid", "userInfo"]),
  },
  watch: {},
  methods: {
    async addTree() {
      let _this = this;
      this.$prompt("请输入企业邀请码", "加入企业").then(({ value }) => {
        if (value) {
          ChangeCompanyId({
            code: value,
            uid: localStorage.uid,
          }).then((res) => {
            if (res.Code) this.$message.success("已发送申请");
            else this.$message.error(res.Message);
          });
        } else {
          this.$message.error("请输入邀请码");
          return false;
        }
      });
    },
    // tabClick 点击切换 调用不同接口
    tabClick(tab) {
      if (tab.name == 1) {
      } else if (tab.name == 2) {
        this.GetMsginform();
      } else {
        this.Getscorerecord();
        this.GetConsumeScore();
      }
    },
    //用户信息
    async GetuserInfo() {
      let params = {
        uid: this.uid,
      };
      let res = await this.$store.dispatch("upDateUserInfo");
      this.personForm = res.Data;
      this.imageUrl = this.$store.state.baseUrl + res.Data.user07;
      this.getdeps();
    },
    format(a, b) {
      return this.$store.state.userInfo.isSign ? "1/1" : "0/1";
    },
    cellClass(row) {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    },
    // 个人信息保存 姓名、性别、邮箱
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let id = this.personForm.user01;
          let name = this.personForm.user02;
          let sex = this.personForm.user03;
          let eamil = this.personForm.user04;
          let params = {
            uid: id,
            Name: name,
            Sex: sex,
            Eamil: eamil,
          };
          UpdateUserNameSexEamil(params).then((res) => {
            if (res.Code > 0) {
              this.$message.success("用户信息修改成功！");
              this.GetuserInfo();
            } else {
              this.$message.error("用户信息修改失败。");
            }
          });
          // alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 消息通知 得到列表
    async GetMsginform() {
      this.tableLoading = true;
      let res = await GetMsginform();
      this.msgList = res.Data;
      this.tableLoading = false;
    },
    // 消息通知 处理
    async agreeMsg(id) {
      let params = {
        id: id,
        state: 1,
      };
      let res = await HandleMsg(params);
      this.$message.success("已同意");
      this.GetMsginform();
    },
    async refuseMsg(id) {
      let params = {
        id: id,
        state: 0,
      };
      let res = await HandleMsg(params);
      this.$message.success("已拒绝");
      this.GetMsginform();
    },
    // ids
    handleSelectionChange(val) {
      this.ids = val.map((item) => item.msif01);
    },
    // 批量删除
    deleteInBatches() {
      if (this.ids.length > 0) {
        this.$confirm("确定要删除多个通知么？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let params = {
            ids: this.ids.toString(),
          };
          DelMsg(params).then((res) => {
            this.$message.success("刪除成功");
            this.GetMsginform();
          });
        });
      }
    },
    // 积分记录 获取
    async Getscorerecord() {
      this.tableLoading = true;
      let params = {
        uid: this.uid,
      };
      let res = await Getscorerecord({ params });
      this.IntegrateList = res.Data;
      this.tableLoading = false;
      this.GetuserInfo();
    },
    // 签到 增加积分
    Addscorerecord() {
      let params = {
        uid: localStorage.uid,
      };
      Addscorerecord(params).then((res) => {
        if (res.Code > 0) {
          this.$message.success("每日签到成功");
          this.$store.dispatch("upDateUserInfo");
          // this.personForm.user15 = this.
          console.log(typeof this.personForm.user15, "======");
          this.GetuserInfo();
          this.Getscorerecord();
          this.IntegrateShow = false;
        }
      });
    },
    // 获取用户消耗积分数判断用户级别
    GetConsumeScore() {
      let params = {
        uid: this.personForm.user01,
      };
      GetConsumeScore(params).then((res) => {
        if (res.Code > 0) {
          switch (true) {
            case res.Data < 1000:
              this.pointInt = "助理工程师入门";
              break;
            case 1000 <= res.Data < 2000:
              this.pointInt = "助理工程师一级";
              break;
            case 2000 <= res.Data < 3000:
              this.pointInt = "助理工程师二级";
              break;
            case 3000 <= res.Data < 4000:
              this.pointInt = "助理工程师三级";
              break;
            case 4000 <= res.Data < 6000:
              this.pointInt = "工程师一级";
              break;
            case 6000 <= res.Data < 8000:
              this.pointInt = "工程师二级";
              break;
            case 8000 <= res.Data < 10000:
              this.pointInt = "工程师三级";
              break;
            case 10000 <= res.Data < 13000:
              this.pointInt = "高级工程师一级";
              break;
            case 13000 <= res.Data < 20000:
              this.pointInt = "高级工程师二级";
              break;
            case 20000 <= res.Data < 30000:
              this.pointInt = "高级工程师三级";
              break;
            case 30000 <= res.Data:
              this.pointInt = "教授高级工程师";
              break;
          }
        }
      });
    },
    // 修改头像
    handleAvatarSuccess(res, file) {
      if (res.Code == 1) {
        this.$message({
          type: "success",
          message: "修改头像成功",
        });
        this.imageUrl = URL.createObjectURL(file.raw);
        // console.log(file, "file");
        this.fileinfo = file;
        this.$store.dispatch("upDateUserInfo");
      }
    },

    // 上传头像图片限制
    imageChange(file) {
      debugger;
      const isJPG =
        file.raw.type == "image/jpeg" || file.raw.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      if (isJPG && isLt2M) {
        this.option.img = URL.createObjectURL(file.raw);
        this.picDialogVisible = true;
      }
    },
    // 上传头像图片限制
    beforeAvatarUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("file", this.Uids);
      const isJPG = file.type == "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      if (isJPG && isLt2M) {
        this.option.img = this.imageUrl;
        this.picDialogVisible = true;
      }
      return isJPG && isLt2M;
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      this.$refs.cropper.getCropData((data) => {
        function clearFile(urlData, filename) {
          // 64转file
          if (typeof urlData != "string") {
            this.$toast("目标不是base64字符串");
            return;
          }
          var arr = urlData.split(",");
          var type = arr[0].match(/:(.*?);/)[1];
          var fileExt = type.split("/")[1];
          var bstr = atob(arr[1]);
          var n = bstr.length;
          var u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          return new File([u8arr], "filename." + fileExt, {
            type: type,
          });
        }

        let _this = this;

        let fd = new FormData();
        let ff = {
          file: clearFile(data),
          uid: this.userInfo.user01,
        };

        for (var key in ff) {
          fd.append(key, ff[key]);
        }

        UploadUserImg(fd).then((res) => {
          _this.$message({
            type: "success",
            message: "修改头像成功",
          });
          _this.imageUrl = URL.createObjectURL(clearFile(data));
          _this.$store.dispatch("upDateUserInfo");
        });
        this.picDialogVisible = false;
      });
    },
    // 修改手机号
    changePhone() {
      this.PhoneVisible = true;
    },
    // 验证码
    async send() {
      if (
        this.updatePhoneForm.newPhone == "" ||
        !/^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/.test(
          this.updatePhoneForm.newPhone
        )
      ) {
        this.$message.error("手机号错误");
      } else {
        let params = {
          phonenumber: this.updatePhoneForm.newPhone,
        };
        let res = await SendSMSAsync(params);
        if (res.Code) {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    },
    // 修改手机号确认键
    updatePhoneBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let smsCode = this.updatePhoneForm.smscode;
          let params = {
            newPhoneNum: this.updatePhoneForm.newPhone,
            smsCode: smsCode,
          };
          UpdatePhone(params).then((res) => {
            if (res.Code > 0) {
              this.$message.success("更换号码成功！");
              this.PhoneVisible = false;
              this.GetuserInfo();
            } else {
              this.$message.error("手机号验证码不正确");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 修改密码 UpdatePwd
    changePassword() {
      this.dialogVisible = true;
      this.updatePwdForm = this.$options.data.call(this).updatePwdForm;
    },
    // 修改密码确认键
    updatePwdFormBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let old = this.updatePwdForm.oldpwd;
          let news = this.updatePwdForm.newpwd;
          let uid = this.$store.state.uid;
          let params = {
            oldpwd: old,
            newpwd: news,
            uid: uid,
          };
          UpdatePwd(params).then((res) => {
            if (res.Code > 0) {
              this.$message.success("密码修改成功");
              this.dialogVisible = false;
            } else {
              this.$message.error("旧密码不正确");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    async getdeps() {
      if (this.userInfo.user08 !== null) {
        let params = { companyId: this.userInfo.user08 };
        let res = await GetDeptZTree({ params });
        this.deps = res.Data;
      }
    },
    // 更改部门
    selectDept() {
      let params = {
        uid: this.$store.state.userInfo.user01,
        deptid: this.personForm.user09,
      };
      UpdateUserDept(params).then((res) => {
        if (res.Code > 0) {
          this.$message.success("更改部门成功！");
        }
      });
    },
  },
  created() {
    this.GetuserInfo();
    this.Uids.uid = this.uid;
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.info_zk {
  // 隐藏全选框
  // /deep/ .el-table__header-wrapper .el-checkbox {
  //   display: none;
  // }
  /deep/.el-avatar {
    width: 80px;
    height: 80px;
  }
  /deep/.el-upload {
    width: 100%;
    height: 100%;
  }
  height: 100%;
  // /deep/.el-table__header-wrapper .el-checkbox {
  //   display: none;
  // }
  /deep/.el-progress-bar__outer {
    background: rgba(255, 255, 255, 0.368);
  }
  /deep/.el-tabs__item {
    padding: 0 24.5px;
    span {
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        margin-right: 5px;
      }
    }
  }
  /deep/.el-progress__text {
    color: #fff;
  }
  /deep/.el-table .disabledCheck .cell .el-checkbox__inner {
    display: none !important;
  }
  /deep/.el-tabs__item {
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  /deep/.userInfoMenu .el-tabs__item {
    height: auto;
    display: initial;
    justify-content: space-between;
    align-items: center;
  }
  /deep/.el-form-item__content {
    margin: 0;
  }
  .el-card {
    border-radius: 8px;
    margin: auto;
    width: 80%;
    height: 85%;
  }
  .el-card__header {
    border-bottom: none;
    span {
      letter-spacing: 1px;
      font-size: 18px;
      font-weight: 700;
    }
  }
  .content {
    height: 88%;
    // /deep/.is8-active {
    //   border-right: 4px solid red;
    // }
  }
  .lineSpan {
    border: 1px solid #e4e7ed;
    height: 130px;
    left: 144px;
    top: 0;
    width: 0px;
    position: absolute;
    display: inline-block;
  }
  /deep/.el-tabs {
    height: 100%;
  }
  /deep/.el-tabs__content {
    height: 95%;
  }
  .lineColor {
    width: 92.8%;
    background-image: linear-gradient(
      45deg,
      rgb(46, 156, 253),
      rgb(70, 222, 255)
    );
    height: 122%;
    right: -20px;
    top: -20px;
    position: absolute;
  }
}
</style>
